<script lang="ts">
  import type { SerializedOrderedListBlock } from '../../types'

  let { block }: { block: SerializedOrderedListBlock } = $props()
</script>

<ol class="ordered-list">
  {#each block.items as item, index}
    <li class={['ordered-list-item', { '-style-classic': block.style === 'classic', '-style-structured': block.style === 'structured' }]}>
      {#if block.style === 'classic'}
        <span class="ordered-list-index">{index + 1}.</span>
      {:else}
        <span class="ordered-list-badge">{index + 1}</span>
        {#if index < block.items.length - 1}
          <span class="ordered-list-connector"></span>
        {/if}
      {/if}
      <span class="ordered-list-text">{item}</span>
    </li>
  {/each}
</ol>

<style>
  .ordered-list {
    list-style: none;
    padding: 0;
    display: flex;
    flex-direction: column;
  }

  .ordered-list-item.-style-classic {
    position: relative;
    padding-inline-start: var(--space-9);
    padding-bottom: var(--space-5);
  }

  .ordered-list-item.-style-structured {
    position: relative;
    display: flex;
    align-items: flex-start;
    gap: var(--space-6);
    padding-bottom: var(--space-8);
  }

  .ordered-list-index {
    position: absolute;
    inset-inline-start: 0;
    font-size: var(--font-size-5);
    font-weight: var(--font-weight-4);
    color: var(--color-variant-brand);
  }

  .ordered-list-badge {
    flex: none;
    width: 24px;
    height: 24px;
    border-radius: var(--radius-6);
    background-color: var(--color-variant-brand);
    color: var(--color-white);
    font-size: var(--font-size-3);
    font-weight: var(--font-weight-4);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ordered-list-connector {
    position: absolute;
    inset-inline-start: 11px;
    top: 26px;
    bottom: 0;
    width: var(--border-1);
    background-color: var(--color-border-2);
  }

  .ordered-list-text {
    font-size: var(--font-size-5);
    line-height: var(--line-height-4);
  }
</style>
